export const upyunUpload = '//v0.api.upyun.com/westartrack-file'

const { port, hostname } = window.location
const isDingding = hostname.indexOf('dtwork') > -1
let backDomain = '//api.westartrack.com'
let realBackDomain = '//open-weixin.westartrack.com/'

let isTestHostname = hostname.indexOf('dev.westartrack.com') > -1
if (!isTestHostname) { // 线上环境
  backDomain = isDingding ? '//dtapi.westartrack.com' : '//api.westartrack.com'
  realBackDomain = '//open-weixin.gongchang.com/'
} else { // 测试环境
  if (port === '89') { // 域名端口:89
    backDomain = isDingding ? '//dtapi.dev.westartrack.com:89' : '//api.dev.westartrack.com:89'
    realBackDomain = '//open-weixin.westartrack.com/'
  } else { // 域名端口:93
    backDomain = isDingding ? '//dtapi.dev.westartrack.com:90' : '//api.dev.westartrack.com:90'
    realBackDomain = '//open-weixin.westartrack.com/'
  }
}
export const apiRealBackDomain = realBackDomain
export const apiDomain = backDomain
